import React, { useEffect, useState } from 'react'
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  RadioButton
} from 'carbon-components-react'
import PropTypes from 'prop-types'

import './index.scss'

function Filter({ type, title, key, values }) {
  const [rowData, setRowData] = useState(values)
  const [headerData, setHeaderData] = useState([
    {
      title: key,
      dataIndex: key,
      key: key
    }
  ])

  useEffect(() => {}, [])

  const getRows = (rows) => {
    switch (type) {
      case 'multiple':
        rows.map((row) => (
          <TableRow key={row.id}>
            <TableCell key={row.cells[headerData.key].id}>
              {row.cells[headerData.key].value}
            </TableCell>
          </TableRow>
        ))
        break
      case 'single':
        rows.map((row) => (
          <TableRow key={row.id}>
            <RadioButton
              key={row.cells[headerData.key].id}
              id={row.cells[headerData.key].id}
              labelText={row.cells[headerData.key].value}
              value={row.cells[headerData.key].value}
            />
          </TableRow>
        ))
        break
    }
  }

  return (
    <div key={'filter-' + title}>
      <DataTable
        rows={rowData}
        headers={headerData}
        render={({ rows, headers, getHeaderProps }) => (
          <TableContainer title={title}>
            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader
                      key='table-header'
                      {...getHeaderProps({ header })}
                    >
                      {header.title}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>{getRows(rows)}</TableBody>
            </Table>
          </TableContainer>
        )}
      />
    </div>
  )
}

Filter.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  values: PropTypes.string,
  rows: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
  headers: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string }))
}

export default Filter
